import { createContext, useContext } from 'react';

import type { CosmosDiagnostics } from '@/_contract/diagnostics';
import { DISABLED_DIAGNOSTICS } from '@/_pure/diagnostics';

export const CosmosDiagnosticsContext = createContext<Readonly<CosmosDiagnostics>>(DISABLED_DIAGNOSTICS);
export const useCosmosDiagnostics = () => useContext(CosmosDiagnosticsContext);
